<template>
    <div class="skeleton-feature-loading field-loading" >
        <div class="tree-node-component skeleton-feature field-feature">
            <div class="skeleton-line field-line">
              Fetching...
              <span class="field-loading-dots"></span>
            </div>
        </div>
    </div>
  </template>
  <script lang="ts">
  import { defineComponent } from 'vue'
  export default defineComponent({
    name: 'FieldSkeletonComponent'
  })
  </script>
  
  <style lang="scss" scope>
  .field-loading .field-feature{
    height: 40px !important;
    .field-line{
      width: 100%;
      height: 40px !important;
      background-color: var(--light-300) !important;
      border: 1px solid var(--border-neutral);
      display: flex;
      justify-content: center;
      align-items: center;
      color: var(--text-neutral);
      font-size: var(--fs-11);
      position: relative;
    }
}

.field-loading-dots {
  width: 4px;
  height: 4px;
  border-radius: $br-circle;
  display: block;
  position: absolute;
  right: var(--space-20);
  color: var(--accent-100);
  box-sizing: border-box;
  animation: animloader 1s linear infinite alternate;
  }
  </style>
  